import api from './api';

export const userService = {
  async getProfile() {
    const response = await api.get('/users/me');
    return response.data;
  },

  async updateProfile(data) {
    const response = await api.put('/users/me', data);
    return response.data;
  },

  async getCredits() {
    const response = await api.get('/users/me/credits');
    return response.data;
  },

  async getCreditHistory(params = {}) {
    const response = await api.get('/users/me/credits/history', { params });
    return response.data;
  },

  async getCreditSummary() {
    const response = await api.get('/users/me/credits/summary');
    return response.data;
  },

  async getCreditUsage(params = {}) {
    const response = await api.get('/users/me/credits/usage', { params });
    return response.data;
  },

  async getStats() {
    const response = await api.get('/users/me/stats');
    return response.data;
  },

  async deleteAccount() {
    const response = await api.delete('/users/me');
    return response.data;
  },
};

export default userService;
